export const FAQ_SCHEMA_URL = 'https://withjoy.com/assets/public/schemas/faqSchemaV1_0_1.json' as const;
export const FAQ_COMPONENT_TYPE = 'Faq' as const;
